import { useEffect, useState } from 'react';
// @mui
import { MenuItem, Stack } from '@mui/material';
// hooks
import useLocales from '../../../hooks/useLocales';
// components
import Image from '../../../components/Image';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { tx } from '@transifex/native';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleChangeLang = (newLang, name) => {
    onChangeLang(newLang);
    setCurLang(name)
    handleClose();
  };


  tx.init({
    // Public project token, defaults to empty string
    token: '1/b94f210eb8e7da2fb7e94875f3b6f1f95a2e3651',//todo: auth problem to be fixed. dummy commit for pipeline test
  });

  // let langListFromTx = []
  const[langListFromTx, setLangListFromTx] = useState([])
  const[curLang, setCurLang] = useState("")
  const getTxLanguages = () => {
    tx.getLanguages()
    .then(languages => {
      languages.sort((a,b) => a.name.localeCompare(b.name));
      setLangListFromTx(languages)
      console.log("languages from transifex");
      console.log(languages);
      // [{
      //   name: 'Greek',
      //   code: 'el',
      //   localized_name: 'Ελληνικά',
      //   rtl: false,
      // }, {
      //   ...
      // }]
    })
    .catch(console.log);
  }
  useEffect(()=>{
    getTxLanguages();
  },[])
  

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          width: 100,
          height: 40,
          ...(open && { bgcolor: 'action.selected' }),
        }}
      >
        <p style={{fontSize:15}}>{curLang || "English"}</p>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          overflow: 'scroll',
          height: '33%',
          mt: 1.5,
          ml: 0.75,
          width: 180,
          '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
        }}
      >
        <Stack spacing={0.75}>
          {
            langListFromTx.map((option) => (
              <MenuItem
                key={option.code}
                selected={option.code === currentLang.code}
                onClick={() => handleChangeLang(option.code, option.name)}
              >

                {option.name}
              </MenuItem>
            ))
          }
        </Stack>
      </MenuPopover>
    </>
  );
}
